import { useLocalStorage } from '#/hooks/use-local-storage';

/**
 * Custom hook to manage the privacy confirmation
 *
 * @returns A tuple with a boolean value and a function to set the value
 */
export function usePrivacy() {
  const [confirmed, setConfirm] = useLocalStorage<boolean | null>('privacy', null);
  return [confirmed, setConfirm] as const;
}
